import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import Testlist from './Testlist.json';
import {TestDialogComponent} from '../test-dialog/test-dialog.component';
import {ActivatedRoute} from '@angular/router';
import {HttpClient} from '@angular/common/http';
import {ContractsService} from 'src/app/services/contracts.service';
import {CreateExecutionDTO} from 'src/app/model/dto/executions/create-execution-dto';
import {MatSnackBar} from '@angular/material/snack-bar';
import {TestDialogInfoComponent} from '../test-dialog-info/test-dialog-info.component';
import {CookieService} from 'ngx-cookie-service';
import {BoxesService} from 'src/app/services/boxes-service';
import {
  BoxInterfaceInfoDialogComponent
} from '../../boxes/box-interface-info-dialog/box-interface-info-dialog.component';
import {Box} from 'src/app/model/box';
import {catchError} from 'rxjs/internal/operators/catchError';
import {FormControl} from '@angular/forms';


@Component({
  selector: 'aw-test-list-page',
  templateUrl: './test-list-page.component.html',
  styleUrls: ['./test-list-page.component.scss']
})
export class TestListPageComponent implements OnInit {

  loading = true;
  testsRunning = false;
  box_status= [];
  response = null;
  filter: any[] | null = null;
  query = "";
  resume = [];
  private sub: any;
  next: boolean = false;
  page = 1;
  id: number;
  searchIfaceList: string[] = [];
  searchUneceList: string[] = [];
  errorMessage: string | null = null;
  isForbidden: boolean = false;
  CIAControls = new FormControl([]);
  CIAoptions = [ "Confidentiality", "Integrity", "Availability"];
  StrideControls = new FormControl([]);
  StrideOptions = [
    {
      title: "Spoofing",
      value: "Spoofing"
    },
    {
      title: "Tampering",
      value: "Tampering"
    },
    {
      title: "Repudiation",
      value: "Repudiation"
    },
    {
      title: "Information Disclosure",
      value: "informationdisclosure"
    },
    {
      title: "Denial of Service",
      value: "dos"
    },
    {
      title: "Elevation of Privilege",
      value: "elevationofprivilege"
    }
  ];

  UneceOptions = [
    "Back-end servers used as a means to attack a vehicle or extract data (slt.001)",
    "Services from back-end server being disrupted, affecting the operation of a vehicle (slt.002)",
    "Vehicle related data held on back-end servers being lost or compromised ('data breach') (slt.003)",
    "Spoofing of messages or data received by the vehicle (slt.004)",
    "Communication channels used to conduct unauthorized manipulation, deletion or other amendments to vehicle held code/data (slt.005)",
    "Communication channels permit untrusted/unreliable messages to be accepted or are vulnerable to session hijacking/replay attacks (slt.006)",
    "Information can be readily disclosed (slt.007)",
    "Denial of service attacks via communication channels to disrupt vehicle functions (slt.008)",
    "An unprivileged user is able to gain privileged access to vehicle systems (slt.009)",
    "Viruses embedded in communication media are able to infect vehicle systems (slt.010)",
    "Messages received by the vehicle (for example X2V or diagnostic messages), or transmitted within it, contain malicious content (slt.011)",
    "Misuse or compromise of update procedures (slt.012)",
    "It is possible to deny legitimate updates (slt.013)",
    "Legitimate actors are able to take actions that would unwittingly facilitate a cyber-attack (slt.015)",
    "Manipulation of the connectivity of vehicle functions enables a cyber-attack (slt.016)",
    "Hosted 3rd party software (slt.017)",
    "Devices connected to external interfaces (slt.018)",
    "Extraction of vehicle data/code (slt.019)",
    "Manipulation of vehicle data/code (slt.020)",
    "Erasure of data/code (slt.021)",
    "Introduction of malware (slt.022)",
    "Introduction of new software or overwrite existing software (slt.023)",
    "Disruption of systems or operations (slt.024)",
    "Manipulation of vehicle parameters (slt.025)",
    "Cryptographic technologies can be compromised or are insufficiently applied (slt.026)",
    "Parts or supplies could be compromised to permit vehicles to be attacked (slt.027)",
    "Software or hardware development permits vulnerabilities (slt.028)",
    "Network design introduces vulnerabilities (slt.029)",
    "Physical loss of data loss (slt.030)",
    "Unintended transfer of data can occur (slt.031)",
    "Physical manipulation of systems can enable an attack (slt.032)",
    "Security test of system vulnerability (GB-7.1.1.1)",
    "Security test of network ports other than those required by service  (GB-7.1.1.2)",
    "Security test of verification of authenticity and integrity (GB-7.1.2.1)",
    "Security test of authority control of remote control instruction (GB-7.1.2.2)",
    "Security test of security log record (GB-7.1.2.3)",
    "Security test of integrity (GB-7.1.2.4)",
    "Security test of verification of authenticity and integrity (GB-7.1.3.1)",
    "Security test of access control (GB-7.1.3.2)",
    "Security test of access control of external interfaces (GB-7.1.4.1)",
    "Security test of access control of USB interface and SD card interface (GB-7.1.4.2)",
    "Security test of anti virus of USB (GB-7.1.4.3)",
    "Security test of identity authentication of diagnostic interfaces (GB-7.1.4.4)",
    "Security test of the authenticity of the identity of communication with cloud platform (GB-7.2.1)",
    "Security test of identification protection of denial of service attack (GB-7.2.10)",
    "Security test of identification of malicious data (GB-7.2.11)",
    "Security test of communication cybersecurity log (GB-7.2.12)",
    "Security test of identity authentication of V2X communication (GB-7.2.2)",
    "Security test of integrity of communication channels (GB-7.2.3)",
    "Security test against physical manipulation attacks (GB-7.2.7)",
    "Security test of prevention of unauthorized operation (GB-7.2.4)",
    "Security test of verifying the validity or uniqueness of the critical instruction data (GB-7.2.5)",
    "Security test of the confidentiality of the sensitive personal information (GB-7.2.6)",
    "Security test of prevention of unauthorized privileged access of components and parts for direct communication between the vehicle and the outside (GB-7.2.8)",
    "Security test of in vehicle security area isolation (GB-7.2.9)",
    "Security protection mechanism test (GB-7.3.1.1)",
    "Vulnerability security test (GB-7.3.1.2)",
    "Security test of identity authentication of server (GB-7.3.2.1)",
    "Security test of verification of authenticity and integrity of over the air update package (GB-7.3.2.2)",
    "Security test of over the air update cybersecurity event log (GB-7.3.2.3)",
    "Security test of offline update of update system with using on board software (GB-7.3.3.1)",
    "Security test of offline update of update system without using on board software (GB-7.3.3.2)",
    "Security test of prevention of unauthorized acquisition and access of the key (GB-7.4.1)",
    "Security test of prevention of disclosure of sensitive personal information (GB-7.4.2)",
    "Security test of prevention of unauthorized deletion and modification of sensitive personal information (GB-7.4.3)",
    "Security test of prevention of unauthorized deletion and modification of sensitive personal information (GB-7.4.4)",
    "Security test of prevention of modification and unauthorized deletion of log file (GB-7.4.5)",
    "Test method for personal information erasure function (GB-7.4.6)",
    "Test method for prevention of direct cross border data transfer (GB-7.4.7)",
    "Applicability of access control mechanisms (RED.ACM-1)",
    "Secure updates (RED.SUM-2)",
    "Appropriate access control mechanisms (RED.ACM-2)",
    "Applicability of authentication for network interfaces (RED.AUM-1-1)",
    "Applicability of authentication for user interfaces (RED.AUM-1-2)",
    "Appropriate authentication mechanisms (RED.AUM-2)",
    "Authenticator validation (RED.AUM-3)",
    "Changing authenticators (RED.AUM-4)",
    "Password strength (RED.AUM-5)",
    "Brute force protection (RED.AUM-6)",
    "Applicability of update mechanisms (RED.SUM-1)",
    "Automated updates (RED.SUM-3)",
    "Applicability of secure storage mechanisms (RED.SSM-1)",
    "Integrity protection for secure storage (RED.SSM-2)",
    "Confidentiality protection for secure storage (RED.SSM-3)",
    "Applicability of secure communication mechanisms (RED.SCM-1)",
    "Integrity and authenticity protection for communications (RED.SCM-2)",
    "Confidentiality protection for communications (RED.SCM-3)",
    "Replay protection for communications (RED.SCM-4)",
    "Resilience mechanisms (RED.RLM-1)",
    "Network monitoring mechanisms (RED.NMM-1)",
    "Traffic control mechanisms (RED.TCM-1)",
    "Appropriate confidential cryptographic keys (CCKs) (RED.CCK-1)",
    "CCK generation mechanisms (RED.CCK-2)",
    "Preventing static default pre-installed keys (RED.CCK-3)",
    "Up-to-date software and hardware (RED.GEC-1)",
    "Limit exposure of services (RED.GEC-2)",
    "Configuration of optional services (RED.GEC-3)",
    "Documentation of exposed interfaces and services (RED.GEC-4)",
    "No unnecessary external interfaces (RED.GEC-5)",
    "Input validation (RED.GEC-6)",
    "Best practice cryptography (RED.CRY-1)",
  ];
  UneceControls = new FormControl([]);
  InterfaceOptions ;
  //   {
  //     target_name: "bluetooth"
  //   },
  //   {
  //     target_name: "ethernet"
  //   },
  //   {
  //     target_name: "uds on can"
  //   },
  //   {
  //     target_name: "uds on doip"
  //   }
  // ];
  InterfaceControls = new FormControl([]);

  REG_ID = /^(?<content>.*?)(?=\s*\((?<id>(?:slt\.\d+|gb-\d+(?:\.\d+)+|red\.[a-z]+-\d+(?:-\d+)*))\))/i;

  @ViewChild('ciaTooltipContent') ciaTooltipContent!: ElementRef;

  setTooltipContent(content: string) {
    // This method will be used to set the tooltip content dynamically
    const tooltipElement = this.ciaTooltipContent.nativeElement;
    tooltipElement.setAttribute('title', content);
  }

  removeCIAFilter(cia: string) {
    let CIAlist = this.CIAControls.value;
    const index = CIAlist.indexOf(cia);

    if (index >= 0)
      CIAlist.splice(index, 1);

    this.CIAControls.setValue(CIAlist);

  }

  removeStrideFilter(cia: string) {
    let Stridelist = this.StrideControls.value;
    const index = Stridelist.indexOf(cia);

    if (index >= 0)
      Stridelist.splice(index, 1);

    this.StrideControls.setValue(Stridelist);

  }

  removeUneceFilter(unece: string) {
    let Unecelist = this.UneceControls.value;
    const index = Unecelist.indexOf(unece);

    if (index >= 0)
      Unecelist.splice(index, 1);

    this.UneceControls.setValue(Unecelist);

  }
  removeInterfaceFilter(iface: string) {
    let Interfacelist = this.InterfaceControls.value;
    const index = Interfacelist.indexOf(iface);

    if (index >= 0)
      Interfacelist.splice(index, 1);

    this.InterfaceControls.setValue(Interfacelist);

  }

  extractRegulationId(text: string): string | null {
    return this.REG_ID.exec(text)?.groups?.id ?? null;
  }


  constructor(public dialog: MatDialog,
    private cookieService: CookieService,
    private route: ActivatedRoute,
    private http: HttpClient,
    private contractService: ContractsService,
    private boxService: BoxesService,
    private _snackBar: MatSnackBar
  ) { }

  ngOnInit(): void {
    this.sub = this.route.params.subscribe(params => {
      this.id = (params['id']);
    });

    this.contractService.getIntefaceTargetList(this.id).subscribe(response => {
      this.InterfaceOptions = response.data.targets;
    });

    this.boxService.getAllBoxesByContract(this).subscribe(response => {
      this.box_status=response;
  });
    this.response = Testlist.Testlist;
    this.contractService.getContractsTestList(this.id)
    .pipe(
      catchError(error => {
        this.loading = false;

        if (error.message == "aw.api.errors.forbidden"){
          this.errorMessage = 'The user is not authorized to fetch the test list of this contract.';
          this.isForbidden = true;
        }else
          this.errorMessage = 'An error occurred while fetching the test list. Please try again later.';


        return of({ data: { testlist: [] }, next: null });
    })
    ).subscribe(response => {
      let res = response as any;
      if (res.data) {
        this.filter = res.data.testlist;
        if (res.next)
          this.next = true;
        this.response = res;
        this.isForbidden = false;
      }
      else {
        this.errorMessage = 'No Testlist is suitable for the specific contract.';
        this.filter = [];
        this.next = false;
        this.isForbidden = false;
      }
      this.loading = false;
    });

    let cookieData = this.cookieService.get(this.id.toString())

    if (cookieData.length > 0) {
      this.resume = JSON.parse(cookieData)
    }
    else this.cookieService.set(this.id.toString(), JSON.stringify([]))
  }

  openDialog(test) {
    const dialogRef = this.dialog.open(TestDialogComponent, {
      panelClass: 'modal',
      data: {
        test: test,
        contractID: this.id,
        resume: this.resume
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      let res = result as any[];
      if (res.length > 0) {
        this.resume.push({ title: test.title, forms: res });
      }
      this.cookieService.set(this.id.toString(), JSON.stringify(this.resume));
    });
  }

  openInfoDialog(form) {
    this.dialog.open(TestDialogInfoComponent, {
      data: form
    });
  }

  lauchTests() {
    this.testsRunning = true;
    let executions: CreateExecutionDTO[] = [];
    for (let test of this.resume) {
      for (let form of test.forms) {
        let execution: CreateExecutionDTO = {
          testname: form.testname,
          parameters: form.parameters
        }
        executions.push(execution);
      }
    }

    this.contractService.createExecutionForContract(this.id, executions).subscribe(result => {
        if (result.status === 206) {
          this._snackBar.open(result.body?.message ?? 'Partial execution', '', {
            duration: 5000,
            verticalPosition: 'bottom',
            horizontalPosition: 'left'
          });
        } else {
          this._snackBar.open('Tests in execution...', '', {
            duration: 5000,
            verticalPosition: 'bottom',
            horizontalPosition: 'left'
          });
        }

        this.resume = [];
        this.cookieService.set(this.id.toString(), JSON.stringify(this.resume));
        this.testsRunning = false;
    },
    error => {
        this._snackBar.open('Error launching tests', '', {
          duration: 5000,
          verticalPosition: 'bottom',
          horizontalPosition: 'left',
        });
        this.testsRunning = false;
    });

  }

  search() {
    this.loading = true;
    this.errorMessage = null;
    const interfaceValues = this.InterfaceControls.value.map(iface =>
    typeof iface === 'object' ? iface.target_name : iface);
    this.contractService.getContractsTestList(this.id,undefined, undefined, this.query.toLocaleLowerCase(), interfaceValues, this.CIAControls.value, this.getStrideForSearch(), this.UneceControls.value)
    .pipe(
      catchError(error => {
        this.loading = false;
        this.errorMessage = 'An error occurred while fetching the test list. Please try again later.';
        this.filter = [];
        this.next = false;
        return of({ data: { testlist: [] }, next: null });
    })
    ).subscribe(response => {
      let res = response as any;
      if (res.data != null) {
        if (res.next != null)
          this.next = true;
        else
          this.next = false;
        this.filter = res.data.testlist;
        this.page = 1;
      }
      else {
        this.errorMessage = 'No Testlist is suitable for the specific contract.';
        this.filter = [];
        this.next = false;
      }
      this.loading = false;
    });
  }

  deleteTest(form) {
    for (let i = 0; i < this.resume.length; i++) {
      this.resume[i].forms = this.resume[i].forms.filter(item => item !== form);
      if (this.resume[i].forms.length === 0) {
        this.resume.splice(i, 1);
      }
    }
    this.cookieService.set(this.id.toString(), JSON.stringify(this.resume));
  }

  loadMore() {
    if (this.next) {
      this.page += 1;
      const interfaceValues = this.InterfaceControls.value.map(iface =>
      typeof iface === 'object' ? iface.target_name : iface);
      this.contractService.getContractsTestList(this.id,this.page, undefined, this.query, interfaceValues, this.CIAControls.value, this.getStrideForSearch(), this.UneceControls.value).subscribe(response => {
        let res = response as any;
        if (!res.next)
          this.next = false;
        this.filter.push(...res.data.testlist);
      });
    }
  }

  // receiveIface(event: string) {
  //   const index = this.searchIfaceList.indexOf(event);

  //   if (index < 0)
  //     this.searchIfaceList.push(event);
  // }

  // receiveUnece(event: string) {
  //   const index = this.searchUneceList.indexOf(event);

  //   if (index < 0)
  //     this.searchUneceList.push(event);

  // }

  // removeIfaceFromSearch(iface: string) {
  //   const index = this.searchIfaceList.indexOf(iface);

  //   if (index >= 0)
  //     this.searchIfaceList.splice(index, 1);

  // }

  // removeUneceFromSearch(unece: string) {
  //   const index = this.searchUneceList.indexOf(unece);

  //   if (index >= 0)
  //     this.searchUneceList.splice(index, 1);

  // }

  showBoxInfo(box: Box) {
    this.dialog.open(BoxInterfaceInfoDialogComponent, {
      data : {
        contract: this.id,
        box: box
      }
    })
  }

  getStrideForSearch() {
    return this.StrideControls.value.map(obj => obj.value);
  }

}
function of(arg0: { data: { testlist: undefined[]; }; next: null; }): any {
  throw new Error('Function not implemented.');
}

